<template>
    <div class="user-dashboard-wrapper">
        <TimeTracker />
        <Projects />
    </div>
</template>

<script>
import TimeTracker from '@/components/Dashboard/Dev/TimeTracker';
// import Notifications from '@/components/Dashboard/Dev/Notifications';
import Projects from '@/components/Dashboard/Dev/Projects';

export default {
    components: {
        TimeTracker,
        // Notifications,
        Projects,
    },
};
</script>
